export default __webpack_public_path__ + "5d5651cd864d64df3e56b98e4f07e9ab.svg";